import { GRAFICO_COLOR_A, GRAFICO_COLOR_B } from './grafico-pie';

export interface SerieChartData {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    backgroundColor: string;
    borderColor: string;
  }[];
}

function pad2(value: number): string {
  return String(value).padStart(2, '0');
}

export function formatIso(date: Date): string {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

export function formatDisplay(iso: string): string {
  const [year, month, day] = iso.split('-');
  return `${day}-${month}-${year}`;
}

export function addDaysIso(iso: string, days: number): string {
  const [year, month, day] = iso.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + days);
  return formatIso(date);
}

/** Siete domingos: índice 0 es la fecha base, índice 6 es 42 días atrás. */
export function fechasSemana(baseIso: string): string[] {
  return [0, 7, 14, 21, 28, 35, 42].map((offset) => addDaysIso(baseIso, -offset));
}

export function buildDomingoSerie(enCelula: number[], sinCelula: number[], labels: string[]): SerieChartData {
  return {
    labels,
    datasets: [
      {
        label: 'Pers. en célula',
        data: enCelula,
        backgroundColor: GRAFICO_COLOR_A,
        borderColor: GRAFICO_COLOR_A,
      },
      {
        label: 'Pers. sin célula',
        data: sinCelula,
        backgroundColor: GRAFICO_COLOR_B,
        borderColor: GRAFICO_COLOR_B,
      },
    ],
  };
}

export function buildCelulaSerie(presentes: number[], ausentes: number[], labels: string[]): SerieChartData {
  return {
    labels,
    datasets: [
      {
        label: 'Presentes',
        data: presentes,
        backgroundColor: GRAFICO_COLOR_A,
        borderColor: GRAFICO_COLOR_A,
      },
      {
        label: 'Ausentes',
        data: ausentes,
        backgroundColor: GRAFICO_COLOR_B,
        borderColor: GRAFICO_COLOR_B,
      },
    ],
  };
}
